export default function initializeImageSlider() {
  document.querySelectorAll('.image-slider:has(.image-slider__swiper)').forEach(function (block) {
    new ImageSlider(block);
  });

  initScrollAnimation();
}

function initScrollAnimation() {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.front-image-slider-item__scroll-animation');
    console.log(trigger);
    if (!trigger) return;

    const imageSlider = trigger.closest('.image-slider');
    if (!imageSlider) return;

    e.preventDefault();
    const headerHeight = document.querySelector('.header').offsetHeight;
    const height = imageSlider.offsetHeight - headerHeight;
    window.scrollBy({ top: height, behavior: 'smooth' });
  });
}

class ImageSlider {
  constructor(block) {
    this.block = block;
    this.init();
  }

  init() {

    import('swiper/bundle').then(({ default: Swiper }) => {

      var timer;

      window.addEventListener('resize', () => {
        if (timer) {
          clearTimeout(timer);
        }

        timer = setTimeout(() => this.initSwiper(Swiper), 200);
      });
      this.initSwiper(Swiper);

    });
  }


  initSwiper(Swiper) {

    const slider = this.block.querySelector('.image-slider__swiper');

    const blockSwiperArgs = {
      speed: 1000,
      loop: true,
      spaceBetween: 0,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: slider.querySelector('.image-slider__arrow--next'),
        prevEl: slider.querySelector('.image-slider__arrow--prev'),
      },
    };


    if (this.block.dataset.swiperConfig) {
      const config = JSON.parse(this.block.dataset.swiperConfig);
      // merge config with default args
      Object.assign(blockSwiperArgs, config);

      if (this.block.dataset.swiperCustomConfig) {
        const customConfig = JSON.parse(this.block.dataset.swiperCustomConfig);
        // merge custom config with default args
        Object.assign(blockSwiperArgs, customConfig);
      }
    }

    const swiper = new Swiper(slider, blockSwiperArgs);
    swiper.autoplay.stop();
    if (blockSwiperArgs.autoplay !== false) {
      new IntersectionObserver((entries, observer) => {
        // jeśli slider jest w obszarze widoczności to uruchom autoplay
        if (entries[0].isIntersecting) {
          observer.disconnect();
          swiper.autoplay.start();
        }
      }).observe(slider);
    }
  }
}